const styles = (theme) => ({
  root: {
    flexWrap: 'nowrap',
    padding: theme.spacing(1.25),
    borderRadius: 3,
    lineHeight: 1.25,
  },
  anchorOriginBottomCenter: {
    bottom: theme.mixins.toolbar.minHeight + 10,
  },
  success: {
    backgroundColor: theme.palette.success.main,
  },
  error: {
    backgroundColor: theme.palette.error.main,
  },
  info: {
    backgroundColor: theme.palette.info.main,
  },
  warning: {
    backgroundColor: theme.palette.warning.main,
  },
  icon: {
    opacity: 0.9,
    fill: theme.color.white,
    width: theme.spacing(2.5),
    height: theme.spacing(2.5),
  },
  message: {
    display: 'flex',
    alignItems: 'center',
  },

  snackbarMessage: {
    padding: 0,
  },

  snackbarAction: {
    marginRight: theme.spacing(-1.25),
    paddingLeft: theme.spacing(1),
  },

  messageText: {
    marginLeft: theme.spacing(2),
    overflow: 'auto',
    wordBreak: 'break-word',
    maxHeight: '30vh',
    fontSize: '16px',
  },

  closeIcon: {
    padding: 0,
    paddingRight: theme.spacing(1.25),
  },

  description: {
    margin: 0,
    marginTop: theme.spacing(1),
  },
});

export default styles;
